<template>
  <div>
    <table-base ref="table" GetAction="GetList" Controller="Wages" DelAction="Del" :TopButtons="TopButtons" :TopSeach="TopSeach" :TableColumns="TableColumns" @topButtonClick="topButtonClick" :TableButtons="TableButtons"></table-base>
    <el-dialog title="预览" :visible.sync="showInfo" width="80%" :before-close="()=>{showInfo = false}">
      <span>
        <el-row>导入条数：{{ylList.length}} <label>实发合计：{{total}}</label> </el-row>
        <el-table border :data="ylList" style="width: 100%">
          <div v-for="item in TableColumns" :key="item.param">
            <el-table-column v-if="item.type != 'index'" :prop="item.param" :label="item.name"></el-table-column>
          </div>

        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInfo = false">取 消</el-button>
        <el-button type="primary" @click="Save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "Wages",
    title: "工资上传",
    data () {
      return {
        TopButtons: [
          { name: "导入", action: "input", back: this.Input },
          { name: "模板下载", action: "template" },
        ],
        TopSeach: [
          { name: "年份", clearable: true, param: "year", default: "", type: "select", action: "Year", span: 6 },
          { name: "月份", clearable: true, param: "month", default: "", type: "select", select: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], span: 6 },
          { name: "", param: "input", default: "", type: "text", placeholder: "请输入关键字", span: 8 }
        ],
        TableColumns: [
          { name: "序号", type: "index", param: "", width: "50px" },
          { name: "人员代码", param: "userID" },
          { name: "姓名", param: "userName" },
          { name: "年", param: "year" },
          { name: "月", param: "month" },
          { name: "应发合计", param: "yfhj" },
          { name: "实发合计", param: "sfhj" },
          { name: "累计税", param: "ljs" },
        ],
        TableButtons: [
          { name: "撤销", action: "del", color: "#f56c6c" },
        ],
        showInfo: false,
        ylList: [],
        total: 0
      }
    },
    components: {
      TableBase: resolve => require(["@/components/System/components/TableBase"], resolve)
    },
    created () {
      this.Ajax.Get("api/Wages/GetProp").then(res => {
        this.TableColumns = [{ name: "序号", type: "index", param: "", width: "50px" }];
        res.data.forEach(item => {
          var prop = "";
          for (let i = 0; i < item.key.length; i++) {
            const key = item.key.substr(i, 1);
            if (f_check_uppercase(key))
              prop += key.toLowerCase()
            else {
              prop += item.key.substr(i);
              break;
            }
          }
          if (prop.indexOf("2") > 0) {
            var key = prop.substr(prop.length - 2, 1);
            prop = prop.replace(key, key.toUpperCase());
          }
          this.TableColumns.push({
            param: prop,
            name: item.value
          });
        });
      })
    },
    mounted () {

    },
    methods: {
      topButtonClick (type) {
        if (type == "template") {
          window.open("../../template/工资信息导入模板.xls");
        }
      },
      Input (res, file, fileList) {
        this.Ajax.Post("api/Wages/InputData", [res.data]).then(res => {
          this.ylList = res.data;
          this.total = 0;
          res.data.forEach(item => {
            this.total += parseFloat(item.sfhj);
          });
          console.log(this.ylList);
          this.total = this.$tool.floatFormat(this.total);
          this.showInfo = true;
          //this.$tool.System.msg("导入成功！", "提示", 0);
          //this.$refs.table.GetList();
        });
      },
      Save () {
        this.Ajax.Post("api/Wages/Save", this.ylList).then(res => {
          this.showInfo = false;
          this.$tool.System.msg("导入成功！", "提示", 0);
          this.$refs.table.GetList();
        });
      }
    }
  }

  function f_check_uppercase (obj) {
    if (/^[A-Z]+$/.test(obj)) {
      return true;
    }
    return false;
  }
</script>

<style>
</style>